/* eslint-disable @typescript-eslint/no-explicit-any */
import { Checkbox, CheckboxOnChangeData, makeStyles, mergeClasses, tokens } from "@fluentui/react-components";
import { CustomCardHeader, CustomCardHeaderProps } from "./CustomCardHeader";
import { Column, ColumnProps } from "./Column";
import { useEffect, useState } from "react";
import { appTokens } from "./Styles/appTokens";

const useStyles = makeStyles({
    root: {
        position: 'relative',
        boxSizing: 'border-box'
    },
    noUserSelect: {
        userSelect: 'none'
    },
    selection: {
        position: 'absolute',
        top: '0',
        right: '0'
    },
    subtleBorder: {
        border: `1px solid ${appTokens.border.colors.subtle}`
    }
});
export type BrandCardProps = Partial<Omit<ColumnProps, 'title'>> & {
    title?: string | JSX.Element;
    titleClassName?: string;
    description?: string | JSX.Element;
    action?: JSX.Element;
    headerIcon?: JSX.Element;
    headerComponent?: JSX.Element;
    headerComponentProps?: ColumnProps;
    className?: string;
    selected?: boolean;
    subtleBorder?: boolean;
    onSelectionChange?: (_: any, state: any) => void;
    disabled?: boolean;
    headerProps?: Omit<CustomCardHeaderProps, 'title' | 'description' | 'action' | 'icon' | 'headerComponent' | 'headerComponentProps' | 'disabled'>;
}
export const BrandCard = (props: BrandCardProps) => {

    const { children, className, title, titleClassName, description, action, headerIcon, headerComponent, headerComponentProps, selected, onSelectionChange, subtleBorder, disabled, headerProps, ...otherProps } = props;

    //Styles
    const styles = useStyles();
    const cardStyles = mergeClasses(
        styles.root,
        !!onSelectionChange && styles.noUserSelect,
        !!subtleBorder && styles.subtleBorder,
        className
    )

    const [isSelected, setIsSelected] = useState<boolean>(false);

    //Click Events
    const onClick = (e: any) => {
        e.stopPropagation();
        
        setIsSelected((prev) => !prev);
    }

    //UI
    const SelectCheckbox = (
        <Checkbox onChange={(_e: any, data: CheckboxOnChangeData) => setIsSelected(data.checked as boolean)} checked={selected} />
    )

    useEffect(() => {
        !!onSelectionChange && onSelectionChange(undefined, { selected: isSelected });
    }, [isSelected]);

    return (
        <Column padding='pb-2' flex={props.flex ?? '0 1 auto'}>
            <Column
                padding='px-2 pt-2 pb-3'
                subtleBorder
                shadowSmall
                borderRadius='10px'
                backgroundColor={appTokens.card.background}
                gap='small'
                height='auto'
                className={cardStyles}
                onClick={onClick}            
                {...otherProps}
            >
                {!!onSelectionChange && (
                    <Column className={styles.selection} width='auto' align='right' vAlign='middle' padding='pt-1 pr-1'>
                        {SelectCheckbox}
                    </Column>
                )}

                {(!!title || !!action || !!headerIcon || !!headerComponent) && (
                    <Column padding='px-1 pt-0 pb-1' height='auto' align="right">
                        <CustomCardHeader
                            title={title}
                            titleClassName={titleClassName}
                            description={description}
                            icon={headerIcon}
                            headerComponent={headerComponent}
                            headerComponentProps={headerComponentProps}
                            action={action}
                            disabled={disabled}
                            {...headerProps}
                        />
                    </Column>
                )}
                {children}
            </Column>
        </Column>
    );
}